<template>
  <ajax-select
      v-bind="$attrs"
      :label="label != null ? label : transc('objectGroup.objectGroup', 1)"
      resource-url="object-groups"
      :value="groupId"
      @update:value="$emit('update:groupId', $event)"
  >

  </ajax-select>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import AjaxSelect from '@/components/AjaxSelect';

export default {
  name: 'SelectGroup',
  components: {AjaxSelect},
  mixins: [
    LocaleUtils
  ],
  props: {
    groupId: {
      default () {
        return null;
      }
    },
    label: null
  },
}
</script>
